
<div class="budget_graph" id="{{title}}"></div>